import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.548 2.892a1 1 0 1 1 .904-1.784C17.755 2.782 19.83 6.158 19.83 10c0 3.832-2.08 7.212-5.376 8.891a1 1 0 1 1-.908-1.782c2.628-1.338 4.284-4.03 4.284-7.109 0-3.087-1.651-5.774-4.282-7.108zm-1.214 4.154a1 1 0 1 1 1.332-1.492C14.95 6.7 15.673 8.268 15.673 10c0 1.733-.723 3.3-2.007 4.446a1 1 0 1 1-1.332-1.492c.865-.771 1.339-1.8 1.339-2.954 0-1.154-.474-2.182-1.339-2.954zM1.499 14.001A1.5 1.5 0 0 1 0 12.5v-5A1.5 1.5 0 0 1 1.5 6h2.15l4.725-3.78A1 1 0 0 1 10 3v14a1 1 0 0 1-1.625.781l-4.726-3.78H1.5z"
});

var SvgSoundMajor = function SvgSoundMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgSoundMajor as S };
